import {API_DRIVER} from "../configs/axios";

const CustomerService = {
    getCustomers: (page, rowsPerPage, oldIntegrationId, searchText) => {
        return API_DRIVER.get(`/api/customer`, {
            params: {
                page: page,
                size: rowsPerPage,
                oldIntegrationId: oldIntegrationId,
                searchText: searchText,
            }
        })
    },
    generateNewToken: (integrationId) => {
        return API_DRIVER.get(`/api/customer/newToken/${integrationId}`, {
            withCredentials: true, headers: {
                "Access-Control-Allow-Origin": "*"
            }
        })
    },
    getContactNumbers: (customerId, assistenzaId) => {
        return API_DRIVER.get(`/api/customer/contactNumbers/customer/${customerId}/assistenza/${assistenzaId}`, {
            withCredentials: true, headers: {
                "Access-Control-Allow-Origin": "*"
            }
        })
    },
    getParentCompany: (integrationId) => {
        return API_DRIVER.get(`/api/customer/master-father/${integrationId}/credentials`, {
            withCredentials: true, headers: {
                "Access-Control-Allow-Origin": "*"
            }
        })
    }
}

export default CustomerService
